import Swiper from 'swiper';
import { Navigation, A11y, Autoplay, EffectFade } from 'swiper/modules';
import { animate } from '../../core/animations';
import sliderADA from '../../components/slider/ada';

const populateReviews = async () => {
  const reviews_json = JSON.parse($('[data-featured-reviews-json]').text());
  let reviews_data = [];
  let reviews_html = '';

  // Make sure we have at least the image and link available. Draft products don't have link
  reviews_json.forEach(review => {
    if (review.product_link !== null && (review.illustration !== null || review.product_image !== null)) {
      reviews_data.push(review);
    }
  });

  // Shuffle the array
  if ($('[data-featured-reviews-slider]').data('use-random') === 1) {
    reviews_data = _.shuffle(reviews_data);
  }

  // We just want the first n elements
  reviews_data = reviews_data.slice(0, Number($('[data-featured-reviews-slider]').data('total-reviews')));

  reviews_data.forEach(review => {
    reviews_html += `
      <div class="featured-reviews__review featured-review-item swiper-slide">
        <div class="featured-review-item__container">
          <div class="featured-review-item__image">
            <img loading="lazy" src="${review.product_image}" width="265" height="385" alt="${review.quote.replace(/"/g, "'")}" />
          </div>

          <div class="featured-review-item__text">
            <h2 class="featured-reviews__title" tabindex="0">${$('[data-featured-reviews-slider]').data('title')}</h2>
            <h3 class="featured-review-item__quote" tabindex="0">${review.quote}</h3>
            <p class="featured-review-item__author" tabindex="0">- ${review.author}</p>
            <a class="featured-review-item__product" href="${review.product_link}" tabindex="0">${review.product_title}</a>
          </div>
        </div>
      </div>
    `;
  });

  $('[data-featured-reviews-items]').html(reviews_html);
};

const initSlider = (slider) => {
  const swiper = new Swiper(slider, {
    modules: [ Navigation, A11y, Autoplay, EffectFade ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    autoHeight: false,
    freeMode: false,
    centeredSlides: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: Number($('[data-featured-reviews-slider]').data('slide-delay')),
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      769: {
        freeMode: false,
        autoHeight: false,
        centeredSlides: true,
      }
    },
    on: {
      init: function () {
        animate();
        sliderADA(document.querySelector('.featured-reviews .swiper'));
      },
    }
  });
};

export default async () => {
  if (!$('.featured-reviews .swiper').length || !$('[data-featured-reviews-json]').length) {
    return;
  }

  await populateReviews();

  initSlider('.featured-reviews .swiper');
};
